import axiosClient from '@/api/axiosClient'
import { ApiResponse } from '@/api/services/CustomerService'
import { getCurrentUser } from '@/db/indexedDB'
import { IKyc } from '@/types'

const KYC_PAGE_SIZE = 10

export const KycService = {
  fetchKycs: async (page: number): Promise<ApiResponse<IKyc>> => {
    const user = await getCurrentUser()

    const response = await axiosClient.get(`/users/${user.id}/kycs`, {
      params: { page, limit: KYC_PAGE_SIZE },
    })

    return response.data
  },

  refreshKyc: async (kycId: string): Promise<void> => {
    const user = await getCurrentUser()
    await axiosClient.post(`/users/${user.id}/kyc/${kycId}/refresh`)
  },
}
